import { render, staticRenderFns } from "./jifenDuihuanList.vue?vue&type=template&id=63902fe2&scoped=true"
import script from "./jifenDuihuanList.vue?vue&type=script&lang=js"
export * from "./jifenDuihuanList.vue?vue&type=script&lang=js"
import style0 from "./jifenDuihuanList.vue?vue&type=style&index=0&id=63902fe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63902fe2",
  null
  
)

export default component.exports